import React, { useEffect, useState, useRef } from "react";
import Dashboard from "../assets/images/dashboard.png";
import logosc from "../assets/images/scsbc-logo.png";
import logomain from "../assets/images/logomain.png";
// import Header from "../../layouts/Header";
// import { decodeToken } from "../../utils/commonFunctions";
import { decodeToken } from "../utils/commonFunctions";
import { useChatContext } from "../context/ChatContext";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { toast } from "react-toastify";
import useThrottledClick from "../hooks/useThrottledClick";
import { useLocation } from "react-router-dom";
import SharePopupButton from "./SharePopupButton";
import { SchoolSignupContext } from "../context/SchoolSignupContext";
import "./HomeHeader1.css";
import PersonOutlineIcon from "@mui/icons-material/PersonOutline";
import SettingsIcon from "@mui/icons-material/Settings";


const HomeHeader1 = () => {
  const userTokenData = decodeToken();
  const location = useLocation();
  const { signupData, signupDataSession } = React.useContext(SchoolSignupContext);
  const schoolName = signupDataSession?.schoolName || signupData?.schoolName || "";
  const email = userTokenData?.email || signupDataSession?.email || signupData?.email || "";
  const masterTypeid = Number(
    userTokenData?.masterTypeid ?? signupData?.schoolType ?? signupDataSession?.schoolType
  );
  const isTft = masterTypeid === 1;

  const [, setLoading] = useState(false);
  const { setTitleId ,setInitialStart ,setHighLightBtn} = useChatContext();
  const baseURL = process.env.REACT_APP_BASE_URL; // Ensure this is set in .env file

  const navigate = useNavigate()
  const toggleSidebar = (forceOpen) => {
    let sidebar = document.getElementById("sidebar");
    let content = document.getElementById("content");
    let header = document.getElementById("header");
    if (forceOpen) {
      sidebar?.classList.add("open");
      content?.classList.add("shrink");
      header?.classList.add("shrink");
    } else {
      sidebar?.classList.toggle("open");
      content?.classList.toggle("shrink");
      header?.classList.toggle("shrink");
    }
  };

  useEffect(() => {
    if (userTokenData?.email) {
      toggleSidebar(true); // Sidebar opens only if user is logged in
    } else {
      let sidebar = document.getElementById("sidebar");
      let content = document.getElementById("content");
      let header = document.getElementById("header");

      sidebar?.classList.remove("open");
      content?.classList.remove("shrink");
      header?.classList.remove("shrink");
    }
  }, [userTokenData?.email]);

  const handleEditClick = () => {
    // localStorage.setItem("titleId", ""); // Empty the value
    sessionStorage.setItem("titleId", ""); // Empty the value

    setTitleId("")
    setInitialStart("LearningSupports")
    setHighLightBtn(false)
    navigate("/")
    // add your own logic here (open modal, change title, etc.)
  };

  const handleLogout = async () => {
    // alert("Logout1")
    // localStorage.removeItem("access_token");
    // localStorage.clear();
      await new Promise(res => setTimeout(res, 1000));

  
    setLoading(true)
    const token = localStorage.getItem("access_token"); // Retrieve token
    // localStorage.getItem("access_token")
    if (!token) {
      return;
    }
  
    try {
      const response = await axios.post(
        `${baseURL}/user/logout`,
        // `http://localhost:8000/api/v1/user/logout`,
        {}, // Empty request body
        {
          headers: {
            Authorization: `Bearer ${token}`, // Send token in header
            
            "Content-Type": "application/json",
          },
        }
      );
  
      setLoading(false)
      // Clear token & user data from localStorage
      if(response.data.code === 200){
        setInitialStart(false)
        setHighLightBtn(false)
        localStorage.removeItem("access_token");
        localStorage.removeItem("school_type");
        localStorage.clear();
  
  
        // window.location.href = "/school";
        // navigate("/school")
                        navigate("/landingpage")

        // toast.success(response.data.code)
        toast.success(response.data.message);

        
      }
      else{
        localStorage.clear();
        setInitialStart(false)
        setHighLightBtn(false)
        localStorage.removeItem("access_token");
        localStorage.clear();  
        // navigate("/school")
                        navigate("/landingpage")

    
        // toast.error(response.data.message);

      }

      // Redirect to login page
      // navigate("/"); 
    } catch (error) {
      setInitialStart(false)
        setHighLightBtn(false)
        localStorage.removeItem("access_token");
        localStorage.clear();
        // navigate("/school")
                navigate("/landingpage")


      setLoading(false)
      console.error("Error logging out:", error.response ? error.response.data : error.message);
      // toast.error()
      
    }
  };
  const [throttledContinue, isLoading] = useThrottledClick(handleLogout, 3000);
  const [profileMenuOpen, setProfileMenuOpen] = useState(false);
  const profileMenuRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (profileMenuRef.current && !profileMenuRef.current.contains(e.target)) {
        setProfileMenuOpen(false);
      }
    };
    if (profileMenuOpen) document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [profileMenuOpen]);

  const renderProfileMenu = () => (
    <div className="header-profile-wrap" ref={profileMenuRef}>
      <button
        type="button"
        className="header-profile-icon-btn"
        onClick={() => setProfileMenuOpen((o) => !o)}
        aria-label="Profile menu"
      >
        <PersonOutlineIcon sx={{ fontSize: 28 }} />
      </button>
      {profileMenuOpen && (
        <div className="header-profile-dropdown">
          <div className="header-profile-dropdown-info">
            {schoolName && (
              <div className="header-profile-dropdown-info-row">
                <div className="header-profile-dropdown-school underline-inner">{schoolName}</div>
              </div>
            )}
            {email && (
              <div className="header-profile-dropdown-info-row">
                <div className="header-profile-dropdown-email">{email}</div>
              </div>
            )}
          </div>
          <div className="header-profile-dropdown-menu">
            <button
              type="button"
              className="header-profile-dropdown-item"
              onClick={() => {
                setProfileMenuOpen(false);
                navigate("/settings");
              }}
            >
              <SettingsIcon className="header-profile-dropdown-icon" />
              Settings
            </button>
          </div>
        </div>
      )}
    </div>
  );

  return (
    <header>
      <div className="header-inner">
        <div className="home-icos-btn header home-inner-icons" id="header">
          <div className="header-brand">
            <img
              className="dashboard-btn menu-icon"
              onClick={() => toggleSidebar()}
              src={Dashboard}
              alt="Toggle Sidebar"
            />
            <img
              className={`logo-scsc${isTft ? " logomain" : ""}`}
              src={isTft ? logomain : logosc}
              alt="Home"
              onClick={handleEditClick}
            />
          </div>
          <div className="button-login-inner">
            {location.pathname.includes("/afterchatbot") && (
              <div className="header-share-wrap">
                <SharePopupButton />
              </div>
            )}
            <button
              className={`sign-out-heade${isLoading ? " is-loading" : ""}`}
              onClick={throttledContinue}
              disabled={isLoading}
              aria-busy={isLoading}
            >
              SIGN OUT
            </button>
            {renderProfileMenu()}
          </div>
        </div>
      </div>
    </header>
  );
};

export default HomeHeader1;
